import { useCallback } from 'react'
import { useAppSelector } from 'reduxTyped'
import { sanitizeURL } from '@manychat/manyui'

import {
  SHOW_OFF_YOUR_SITE_NEW_VISITOR_ID_ENG,
  CGT_TEMPLATE_ID_ENG,
  STORY_REPLY_TEMPLATE_ID_ENG,
} from 'common/builder/components/chart/FlowChart/IgOnboardingTourStartBlock/constants'
import { CommentServiceInterface } from 'common/builder/components/chart/FlowChart/lib/services/CommentService/CommentServiceInterface'
import { getById } from 'common/flow/selectors/flowSelectors'
import { analyticsService } from 'utils/services/analytics'

export const useCommentService = (flowId: string | undefined): CommentServiceInterface => {
  const flow = useAppSelector((state) => getById(state, flowId))

  const quickCampaignId = flow?.quick_campaign_id

  const shouldSendEvent = [
    CGT_TEMPLATE_ID_ENG,
    STORY_REPLY_TEMPLATE_ID_ENG,
    SHOW_OFF_YOUR_SITE_NEW_VISITOR_ID_ENG,
  ].includes(flow?.quick_campaign_id || 0)

  const clickUrl = useCallback(
    (url: string) => {
      if (!url) return

      if (shouldSendEvent) {
        analyticsService.sendEvent('COMMENT_NODE_URL_CLICK', {
          flow_id: flowId,
          quick_campaign_id: quickCampaignId,
        })
      }

      window.open(sanitizeURL(url), '_blank')
    },
    [shouldSendEvent, quickCampaignId, flowId],
  )

  return {
    clickUrl,
  }
}
